import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import PersonAddIcon from 'components/material-symbol/icons/PersonAdd'
import TipWell, { TipWellActionButton } from 'components/tip-well'
import { gtmEvent } from 'lib/gtm'
import { OFFERING_TYPES } from 'lib/pga-coach/coach-book-student'
import { useCoachBookStudentNavigation } from 'lib/pga-coach/use-coach-fast-book-student'
import { useStyles } from './styles'

// Fast-book needs the lesson type and one of its locations to preselect it.
// Fast-book hides lesson types with packs until a student with credits is
// picked, so it cannot preselect them and the callout is not shown for them.
const BookStudentCallout = ({ bookingType, setIsOpen }) => {
  const classes = useStyles()
  const history = useHistory()
  const { navigateToBookStudent } = useCoachBookStudentNavigation()

  const trackClick = () =>
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-session-button',
      formLabel: 'offering-details-callout',
    })

  if (bookingType.lessonPacks?.length > 0) {
    return null
  }

  const handleFastBookClick = () => {
    trackClick()
    setIsOpen(false)
    navigateToBookStudent(history, {
      offering: OFFERING_TYPES.PRIVATE,
      lessonTypeId: bookingType.id,
      locationId: bookingType.locations[0].id,
    })
  }

  return (
    <Box className={classes.bookStudentCallout}>
      <TipWell
        icon={PersonAddIcon}
        caption={
          <>
            <Box component="span" className={classes.bookStudentHeadline}>
              Add a student to this offering
            </Box>
            Book them in yourself without waiting for them to book.
          </>
        }
        action={
          <TipWellActionButton onClick={handleFastBookClick}>
            Book a student
          </TipWellActionButton>
        }
      />
    </Box>
  )
}

BookStudentCallout.propTypes = {
  bookingType: PropTypes.shape({
    id: PropTypes.string.isRequired,
    lessonPacks: PropTypes.arrayOf(PropTypes.object),
    locations: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string }))
      .isRequired,
  }).isRequired,
  setIsOpen: PropTypes.func.isRequired,
}

export default BookStudentCallout
